export const validateFormById = id => validateForm(id);

function validateForm(id) {
    const form = document.querySelector(id);
    
    return form == null
        ? false
        : form.reportValidity();
}

function checkForm(id) {
    var form = document.querySelector(id);
    if (form !== null) {
        return form.checkValidity();
    }
    return;
}
